module.exports = __webpack_public_path__ + "img/white_zigzag.78413321.png";